import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const CashTenureApi = createAsyncThunk(
  'CashTenureApi',
  async (cashTenurePayload, { dispatch }) => {
    dispatch({ type: 'CashTenureApi/pending', payload: {} });
    const {
      customerId,
      Authorization,
      customerRefNum,
      loanAmount,
      promoCode = '',
    } = cashTenurePayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'loanbooking3/cashtenuredata',
      payload: {
        loanAmount,
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
        promoCode,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const tenureRes = res;
        dispatch({
          type: 'CashTenureApi/fulfilled',
          payload: tenureRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'CashTenureApi/rejected', payload: err });
      },
    });
  }
);

export const CashTenureApi_extrareducer = {
  [CashTenureApi.pending]: (state, action) => {
    state.cashTenureApiState.isLoading = true;
  },
  [CashTenureApi.fulfilled]: (state, action) => {
    state.cashTenureApiState.isLoading = false;
    state.cashTenureApiState.isSuccess = true;
    state.cashTenureApiState.isError = false;
    state.cashTenureApiState.response = action.payload;
  },
  [CashTenureApi.rejected]: (state, action) => {
    state.cashTenureApiState.isLoading = false;
    state.cashTenureApiState.isSuccess = false;
    state.cashTenureApiState.isError = true;
    state.cashTenureApiState.response = action.payload;
  },
};
